import React from 'react'
import { useTranslation } from 'react-i18next'
import { Linking } from 'react-native'
import { URL_API } from 'react-native-dotenv'

import {
  DefaultButtonWithText,
  StatusMessageContainer,
  StatusText,
} from '../../../App/Components'

import { useParams, useHistory } from '../../../Router'
import { StyledScrollView } from '../../../App/Components/AppContainer'
import { SuccessGif } from '../../../App/Components/BookingSuccess/style'
import verifiedGif from '../../../../assets/verified.gif'
import { useAppSelector } from '../../../store/hooks'
import { getCustomerSession } from '../../../cookies/session.cookies'
import { customerPortalLinks } from '../../../App/Util/customerPortalUrl'
import { useShowError } from '../../../ErrorPage/useShowError'

const AppointmentMovedSuccess = () => {
  const { establishmentId, previousAppointmentId } =
    useParams<{ [key: string]: string }>()
  const { t } = useTranslation()
  const history = useHistory()
  const showError = useShowError()

  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  const { settings, previousAppointments } = useAppSelector(
    (state) => ({
      settings: state.settings.values,
      previousAppointments: state.appointment.previousAppointments,
    })
  )

  const session = getCustomerSession(establishmentId)

  if (!previousAppointments) {
    // previousAppointments should always be in Redux at this point — MoveAppointment
    // fetches them before navigating here. If missing, the move flow was bypassed.
    showError('AppointmentMovedSuccess', 'Appointment data missing — page accessed outside of move flow')
    return null
  }

  const movedDetails = previousAppointments.find(
    (appointment) => appointment.id === Number(previousAppointmentId)
  )

  if (!movedDetails) {
    history.push(prevAppointmentPath)
    return null
  }

  const downloadAppointment = () => {
    Linking.openURL(
      `${URL_API}/anonymous/ics/${session?.token}/${movedDetails.uuid}`
    )
  }

  const hour = movedDetails.date.substr(11, 5)
  const dateFull = new Date(movedDetails.date).toLocaleDateString(
    undefined,
    options
  )

  return (
    <StyledScrollView>
      <SuccessGif source={verifiedGif} />
      <StatusMessageContainer success>
        <StatusText>{t(`Your appointment has been moved to `)}</StatusText>
        <StatusText>
          {dateFull}
          {t(` at `)}
          {hour}
        </StatusText>
        <DefaultButtonWithText
          onPress={downloadAppointment}
          backgroundcolor={settings.backgroundColor}
          fontcolor={settings.highlightColor}
          hoversensitive
        >
          {t('Add to calendar')}
        </DefaultButtonWithText>
        <DefaultButtonWithText
          onPress={() => Linking.openURL(customerPortalLinks.appointments(establishmentId))}
          backgroundcolor={settings.backgroundColor}
          fontcolor={settings.highlightColor}
          hoversensitive
        >
          {t('Back to appointments')}
        </DefaultButtonWithText>
      </StatusMessageContainer>
    </StyledScrollView>
  )
}

export default AppointmentMovedSuccess
